import React from "react";

/**
 * Presence indicator with tooltip-friendly "online" / "last seen" label.
 * Considers "online" when last_seen_at is within `onlineWindowSec` seconds.
 */
export default function PresenceDot({ lastSeenAt, onlineWindowSec = 300, compact = false, className = "" }) {
  const now = Date.now();
  let dt = null;
  if (lastSeenAt) {
    try { dt = new Date(lastSeenAt); } catch { dt = null; }
  }
  const secondsAgo = dt ? Math.floor((now - dt.getTime()) / 1000) : null;
  const online = secondsAgo != null && secondsAgo <= onlineWindowSec;

  const label = (() => {
    if (secondsAgo == null) return "Offline";
    if (online) return "Online";
    if (secondsAgo < 3600) return `Seen ${Math.floor(secondsAgo / 60)}m ago`;
    if (secondsAgo < 86400) return `Seen ${Math.floor(secondsAgo / 3600)}h ago`;
    if (secondsAgo < 604800) return `Seen ${Math.floor(secondsAgo / 86400)}d ago`;
    return "Offline";
  })();

  if (compact) {
    return (
      <span
        title={label}
        className={`inline-block h-2.5 w-2.5 rounded-full ${online ? "bg-emerald-500 animate-pulse" : "bg-slate-300"} ${className}`}
        data-testid="presence-dot"
      />
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-bold ${
        online ? "text-emerald-600" : "text-slate-400"
      } ${className}`}
      data-testid="presence-label"
    >
      <span className={`h-1.5 w-1.5 rounded-full ${online ? "bg-emerald-500 animate-pulse" : "bg-slate-300"}`} />
      {label}
    </span>
  );
}
